module.exports = __webpack_public_path__ + "img/Ekstrafer_Gray_1280x1010.cd3d0196.jpg";